import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
import React, { Component } from 'react';
import { TextField, Button } from "monday-ui-react-core";
import QuantitySelector from '../QuantitySelector/QuantitySelector';
import CreatableSelect from 'react-select/creatable';


class Table extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: this.props.products,
            poItems: this.props.items,
            filteredProducts: this.props.products,
            showFilter: false,
            stockBoardColumns: [],
            stockBoardValues: [],
        }

        this.onShowFilterChange = this.onShowFilterChange.bind(this);
    }

    onShowFilterChange() {
        this.setState({showFilter: !this.state.showFilter});
    }

    editProduct(index, value) {
        this.props.editProduct(index, value);
    }

    editSupplier(index, value) {
        this.props.editSupplier(index, value);
    }

    handleCreateProduct(index, value) {
        this.props.createProduct(index, value);
    }

    handleCreateSupplier(index, value) {
        this.props.createSupplier(index, value);
    }

    render() {
        const columns = [
            {
                Header: 'Product',
                accessor: 'product', // accessor is the "key" in the data
                Cell: (cell) => {
                    return (
                        <>
                            <CreatableSelect
                                isClearable
                                onChange={(value) => this.editProduct(cell.index, value)} 
                                onCreateOption={(value) => this.handleCreateProduct(cell.index, value)}
                                options={this.props.products}
                                value={this.props.items[cell.index].product} 
                            />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </>

                    )
                }

            },
            {
                Header: 'Quantity',
                accessor: 'quantity',
                Cell: (cell) => {
                    return <QuantitySelector min={1} value={this.props.items[cell.index].quantity} onChange={ (value) => this.props.editQuantity(cell.index, value) } />
                }
            },
            {
                Header: 'Supplier',
                accessor: 'supplier', // accessor is the "key" in the data
                Cell: (cell) => {
                    return (
                        <>
                            <CreatableSelect
                                isClearable
                                onChange={(value) => this.editSupplier(cell.index, value)} 
                                onCreateOption={(value) => this.handleCreateSupplier(cell.index, value)}
                                options={this.props.suppliers}
                                value={this.props.items[cell.index].supplier} 
                            />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </>

                    )
                }

            },
            {
                Header: 'Notes',
                accessor: 'notes',
                Cell: (cell) => {
                    return <TextField value={this.props.items[cell.index].notes} onChange={ (value) => this.props.editNote(cell.index, value) } />
                }
            },
            {
                Header: 'File',
                accessor: 'file',
                Cell: (cell) => {
                    return <input type="file" onChange={ (value) => this.props.handleUploadFile(cell.index, value) } />
                }
            },
            {
                Header: '',
                accessor: '',
                Cell: (cell) => {
                    return <Button marginLeft marginRight onClick={() => this.props.removeItem(cell.index)} > Remove Item </Button>
                }
            }
         ]
        return ( 
            <>
                <ReactTable
                    showPagination={false}
                    data={this.props.items}
                    minRows={3}
                    columns={columns}
                    className={"table table-bordered table-hover"}
                    noDataText={"Please add an item to the purchase order"}
                />
            </>
        );
    }
}

export default Table;
